import { createAsyncThunk } from '@reduxjs/toolkit';
import MarketplaceCategoriesResource from 'api/service/MarketplaceCategoriesResource';

export const listCategories = createAsyncThunk('marketplace/listCategories', async (_, { rejectWithValue }) => {
  const marketplaceCategoriesResource = new MarketplaceCategoriesResource();
  const { status, data } = await marketplaceCategoriesResource.list({ size: 100, offset: 0 });
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Categories not found.');
});
